const places = {
  saudiArabia: 'Saudi Arabia',
  region: 'Region',
  governorate: 'Governorate',
  district: 'District',
};

export default places;
